import { observer } from 'mobx-react';
import * as React from 'react';
import ProgramStore from '../../../ProgramStore';
import {
  ActiveProgram,
  ProgramDetailResource,
  ProgramProductDetails,
} from '../../../ProgramStore/Types';
import {
  ProgramCard,
  ProgramCardActions,
  ProgramCardBody,
  ProgramCardFooter,
  ProgramCardHeader,
  ProgramCardTitle,
} from '../../Dashboard/ProgramCard';
import LiveSessions from '../../Dashboard/ProgramCard/LiveSessions';
import ProgramCardTeam from '../../Dashboard/ProgramCard/ProgramCardTeam';
import ProgramDropping from '../../ProgramOverview/ProgramOverviewDashboard/ProgramDropping';
import ModuleProgressPanel from './ModuleProgressPanel';
import ResumeCourseButton from './ResumeCourseButton';

interface Props {
  programDetailResource: ProgramDetailResource;
  store: ProgramStore;
  activeProgram: ActiveProgram;
  productDetails: ProgramProductDetails;
}

const ActiveProgramProductOverview: React.FC<Props> = ({
  programDetailResource,
  store,
  activeProgram,
  productDetails,
}) => (
  <ProgramCard data-test-active-program={true}>
    <ProgramCardHeader
      links={programDetailResource.links}
      programInstanceKind={activeProgram.programInstanceKind}
    >
      <ProgramDropping programDetailResource={programDetailResource} programStore={store} />
    </ProgramCardHeader>
    <ProgramCardTitle title={activeProgram.title} />
    <ProgramCardBody>
      <ModuleProgressPanel activeProgram={activeProgram} />
      <ProgramCardActions>
        <ResumeCourseButton programStore={store} />
      </ProgramCardActions>
    </ProgramCardBody>
    <ProgramCardFooter>
      <ProgramCardTeam programId={activeProgram.id} />
      <LiveSessions productDetails={productDetails} />
    </ProgramCardFooter>
  </ProgramCard>
);

export default observer(ActiveProgramProductOverview);
